import { EntityList } from '@avangard/utils/entity';
import { SchoolProfileGroupEntity } from './school-profile-group.entity';

import type { Entity } from './school-profile-group.entity';

class SchoolProfileGroupEntityList extends EntityList<SchoolProfileGroupEntity> {
    constructor(items: Entity[] | null, count?: number | null) {
        super(SchoolProfileGroupEntity, items, count);
    }
}

export { SchoolProfileGroupEntityList };
